import React, { useState, useEffect } from "react";

const useLocalStorage = <TData>(
  key: string,
  initialValue: TData,
): [TData, React.Dispatch<React.SetStateAction<TData>>] => {
  const storedValue = localStorage.getItem(key);
  const [state, setState] = useState<TData>(() => {
    try {
      return storedValue ? JSON.parse(storedValue) : initialValue;
    } catch (error) {
      console.warn(`Failed to parse stored value for key "${key}"`, error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn(`Failed to store value for key "${key}"`, error);
    }
  }, [key, state]);

  return [state, setState];
};

export default useLocalStorage;
